var _rect, _rect2, _g, _g2, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailCreateSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 380,
    viewBox: "0 0 315 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    stroke: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_29177)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#2D87F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_411_29177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1369 33.8793C40.1369 33.7263 40.1263 33.5612 40.1157 33.4036C40.1051 33.1068 40.0066 32.8129 39.8218 32.5297C39.381 31.8571 38.7646 31.5315 37.989 31.5648C37.5755 31.5891 37.262 31.7814 37.0545 32.1374C36.8803 32.4358 36.8363 32.7932 36.9333 33.1174C37.0302 33.4385 37.2514 33.6975 37.5528 33.846C37.7103 33.9293 37.7558 34.002 37.7391 34.1489V34.1534V42.7827C37.7391 42.8054 37.7376 42.8296 37.7361 42.8554C37.733 42.9114 37.7315 42.9705 37.7391 43.028C37.7467 43.1401 37.7103 43.1962 37.6028 43.2416C37.1014 43.4597 36.8651 43.8702 36.903 44.4609C36.9378 45.0713 37.3953 45.5136 38.0133 45.5364C38.0405 45.5379 38.0678 45.5379 38.0951 45.5379C39.2265 45.5379 40.0657 44.5851 40.1187 43.7005C40.1308 43.54 40.1399 43.384 40.1399 43.2219V38.5566C40.1399 38.0386 40.1414 37.5206 40.1429 37.0026C40.1414 35.9801 40.1444 34.9229 40.1369 33.8793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6966 43.2735C34.5042 43.1901 34.4436 43.0826 34.4633 42.8645V34.0747C34.4724 33.9626 34.5118 33.9066 34.6087 33.8687C34.6663 33.846 34.7268 33.8217 34.7753 33.7854C35.2146 33.4961 35.416 32.9508 35.2752 32.4252C35.1222 31.8966 34.7087 31.5739 34.1664 31.5633C34.1528 31.5633 34.1391 31.5633 34.1255 31.5633C33.4818 31.5633 32.9395 31.8239 32.5139 32.3389C32.2155 32.7024 32.0625 33.1477 32.0625 33.6642V38.534C32.0625 39.361 32.0655 40.1865 32.0686 41.009C32.0716 41.83 32.0746 42.6479 32.0746 43.4673C32.0746 44.1762 32.4881 45.0487 33.4136 45.4016C33.656 45.491 33.8832 45.5349 34.0998 45.5349C34.2255 45.5349 34.3467 45.5197 34.4663 45.4894C34.9253 45.3743 35.2615 44.976 35.3206 44.4761C35.3812 43.9702 35.1252 43.4764 34.6966 43.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.492 45.1077L47.4421 44.9729L47.3088 44.9866C47.2209 44.9957 46.8271 45.0108 46.4469 45.0245C45.5941 45.0563 45.4896 45.0638 45.4502 45.0775L45.3639 45.1062L45.3654 45.1986C45.3912 46.5255 44.5248 47.3768 43.7735 47.7024C43.4645 47.8357 43.1176 47.9357 42.7162 48.0054C41.7089 48.1644 40.6926 48.1644 39.6974 48.0054C39.2218 47.9266 38.7977 47.7933 38.4372 47.61C37.9404 47.3525 37.5769 46.9496 37.3587 46.4119C37.3103 46.2922 37.2663 46.1635 37.2239 46.0393C37.1739 45.8939 37.1285 45.756 37.0815 45.6561C36.8771 45.1805 36.3772 44.9245 35.894 45.0472C35.3927 45.1714 35.0594 45.6076 35.0821 46.109C35.0943 46.3998 35.1488 46.6709 35.2715 47.0481C35.3987 47.4267 35.6017 47.8054 35.8546 48.1417C36.3136 48.7642 36.924 49.2414 37.7177 49.5973C38.4811 49.9442 39.3233 50.1486 40.2912 50.2198C40.6426 50.2441 40.9728 50.2562 41.2879 50.2562C41.9589 50.2562 42.5572 50.2017 43.1267 50.0896C43.9704 49.9305 44.6732 49.6791 45.276 49.3231C46.453 48.6234 47.5648 47.7024 47.492 45.1077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.434 35.6469C43.7439 35.6469 41.5552 37.8659 41.5552 40.5939C41.5552 43.3219 43.7439 45.5409 46.434 45.5409C49.1241 45.5409 51.3128 43.3219 51.3128 40.5939C51.3128 37.8659 49.1241 35.6469 46.434 35.6469ZM49.0772 40.5939C49.0772 42.0722 47.8911 43.2764 46.434 43.2764C44.9769 43.2764 43.7909 42.0738 43.7909 40.5939C43.7909 39.1156 44.9769 37.9113 46.434 37.9113C47.8911 37.9113 49.0772 39.114 49.0772 40.5939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5267 40.7952C47.6007 40.1941 47.1734 39.6468 46.5723 39.5728C45.9711 39.4988 45.4238 39.9261 45.3498 40.5272C45.2758 41.1283 45.7031 41.6756 46.3042 41.7496C46.9053 41.8236 47.4526 41.3963 47.5267 40.7952Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 24,
    width: 217.5,
    height: 74,
    rx: 16,
    fill: "#F7F9FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 88.5,
    y: 39,
    width: 102,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 88.5,
    y: 67,
    width: 187.5,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_29177"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_411_29177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 19.25,
    fill: "white",
    transform: "translate(32.0625 31.5625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailCreateSms);
export default __webpack_public_path__ + "static/media/ThumbnailCreateSMS.b3ab7ea27ae9bfbfc242f3ea929d114a.svg";
export { ForwardRef as ReactComponent };